export const userManualDialogChapters = {
  getStartedWelcome: 'getStartedWelcome',
  getStartedGuide: 'getStartedGuide',
  getStartedOverview: 'getStartedOverview',
  dashboardDashboardFunctions: 'dashboardDashboardFunctions',
  bookingsBookingOverview: 'bookingsBookingOverview',
  servicesFuelling: 'servicesFuelling',
  servicesMobileFuelling: 'servicesMobileFuelling',
  servicesParking: 'servicesParking',
  servicesWashing: 'servicesWashing',
  servicesRepairAndMaintenance: 'servicesRepairAndMaintenance',
  servicesCharging: 'servicesCharging',
  vehicleOverview: 'vehicleOverview',
  addingServiceCards: 'addingServiceCards',
  activatingServices: 'activatingServices',
  transactionsList: 'transactionsList',
};

export type UserManualDialogChaptersKeys =
  (typeof userManualDialogChapters)[keyof typeof userManualDialogChapters];
